export enum ImsStatus {
  ReadOnly = "read-only",
  Pending = "pending",
  SourceOfTruth = "source-of-truth",
}
